export const paginationItems = {
    'property-info': 'Property Information',
    'work-info': 'Work Information',
    'other-info': 'Other Information',
    'income-debt-info': 'Income/Debt Information',
    'loan-info': 'Loan Information'
};

export const paginationItemKeys = Object.keys(paginationItems);
export const paginationItemValues = Object.values(paginationItems);